import Q1, { forwardRef as S1, useMemo as J1, useCallback as k1, useId as X1, useRef as m1, useState as w1, useEffect as y1, Fragment as ee, lazy as re, Suspense as te } from "react";
import { ShopfrontSearchDesktop as ne, MobileMenu as oe, ShopfrontSearchMobile as se } from "@intergamma/header";
import { useTranslation as I } from "react-i18next";
import { queryOptions as d1, useQueryClient as T1, useQuery as o1 } from "@tanstack/react-query";
import { ErrorBoundary as le } from "react-error-boundary";
import { getHeaders as ie, AuthDialog as ae } from "@intergamma/account";
import { dispatchAdobeEvent as $ } from "@intergamma/adobe-tracking";
import { UnstyledDialogTrigger as ce } from "@intergamma/dialog";
import g1 from "axios";
import { flushSync as de } from "react-dom";
import { isKiosk as ue } from "@intergamma/kiosk-util";
var a1 = { exports: {} }, X = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L1;
function fe() {
  if (L1) return X;
  L1 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(o, i, l) {
    var c = null;
    if (l !== void 0 && (c = "" + l), i.key !== void 0 && (c = "" + i.key), "key" in i) {
      l = {};
      for (var a in i)
        a !== "key" && (l[a] = i[a]);
    } else l = i;
    return i = l.ref, {
      $$typeof: e,
      type: o,
      key: c,
      ref: i !== void 0 ? i : null,
      props: l
    };
  }
  return X.Fragment = t, X.jsx = n, X.jsxs = n, X;
}
var e1 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R1;
function Ce() {
  return R1 || (R1 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(s) {
      if (s == null) return null;
      if (typeof s == "function")
        return s.$$typeof === K ? null : s.displayName || s.name || null;
      if (typeof s == "string") return s;
      switch (s) {
        case f:
          return "Fragment";
        case w:
          return "Profiler";
        case C:
          return "StrictMode";
        case B:
          return "Suspense";
        case s1:
          return "SuspenseList";
        case D:
          return "Activity";
      }
      if (typeof s == "object")
        switch (typeof s.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), s.$$typeof) {
          case M:
            return "Portal";
          case V:
            return (s.displayName || "Context") + ".Provider";
          case g:
            return (s._context.displayName || "Context") + ".Consumer";
          case E:
            var d = s.render;
            return s = s.displayName, s || (s = d.displayName || d.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
          case l1:
            return d = s.displayName || null, d !== null ? d : e(s.type) || "Memo";
          case Y:
            d = s._payload, s = s._init;
            try {
              return e(s(d));
            } catch {
            }
        }
      return null;
    }
    function t(s) {
      return "" + s;
    }
    function n(s) {
      try {
        t(s);
        var d = !1;
      } catch {
        d = !0;
      }
      if (d) {
        d = console;
        var j = d.error, R = typeof Symbol == "function" && Symbol.toStringTag && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return j.call(
          d,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          R
        ), t(s);
      }
    }
    function o(s) {
      if (s === f) return "<>";
      if (typeof s == "object" && s !== null && s.$$typeof === Y)
        return "<...>";
      try {
        var d = e(s);
        return d ? "<" + d + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var s = z.A;
      return s === null ? null : s.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function c(s) {
      if (x.call(s, "key")) {
        var d = Object.getOwnPropertyDescriptor(s, "key").get;
        if (d && d.isReactWarning) return !1;
      }
      return s.key !== void 0;
    }
    function a(s, d) {
      function j() {
        Q || (Q = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          d
        ));
      }
      j.isReactWarning = !0, Object.defineProperty(s, "key", {
        get: j,
        configurable: !0
      });
    }
    function h() {
      var s = e(this.type);
      return F[s] || (F[s] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), s = this.props.ref, s !== void 0 ? s : null;
    }
    function p(s, d, j, R, Z, N, C1, p1) {
      return j = N.ref, s = {
        $$typeof: L,
        type: s,
        key: d,
        props: N,
        _owner: Z
      }, (j !== void 0 ? j : null) !== null ? Object.defineProperty(s, "ref", {
        enumerable: !1,
        get: h
      }) : Object.defineProperty(s, "ref", { enumerable: !1, value: null }), s._store = {}, Object.defineProperty(s._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(s, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(s, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: C1
      }), Object.defineProperty(s, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: p1
      }), Object.freeze && (Object.freeze(s.props), Object.freeze(s)), s;
    }
    function b(s, d, j, R, Z, N, C1, p1) {
      var H = d.children;
      if (H !== void 0)
        if (R)
          if (i1(H)) {
            for (R = 0; R < H.length; R++)
              k(H[R]);
            Object.freeze && Object.freeze(H);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else k(H);
      if (x.call(d, "key")) {
        H = e(s);
        var U = Object.keys(d).filter(function(K1) {
          return K1 !== "key";
        });
        R = 0 < U.length ? "{key: someKey, " + U.join(": ..., ") + ": ...}" : "{key: someKey}", T[H + R] || (U = 0 < U.length ? "{" + U.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          R,
          H,
          U,
          H
        ), T[H + R] = !0);
      }
      if (H = null, j !== void 0 && (n(j), H = "" + j), c(d) && (n(d.key), H = "" + d.key), "key" in d) {
        j = {};
        for (var h1 in d)
          h1 !== "key" && (j[h1] = d[h1]);
      } else j = d;
      return H && a(
        j,
        typeof s == "function" ? s.displayName || s.name || "Unknown" : s
      ), p(
        s,
        H,
        N,
        Z,
        i(),
        j,
        C1,
        p1
      );
    }
    function k(s) {
      typeof s == "object" && s !== null && s.$$typeof === L && s._store && (s._store.validated = 1);
    }
    var y = Q1, L = Symbol.for("react.transitional.element"), M = Symbol.for("react.portal"), f = Symbol.for("react.fragment"), C = Symbol.for("react.strict_mode"), w = Symbol.for("react.profiler"), g = Symbol.for("react.consumer"), V = Symbol.for("react.context"), E = Symbol.for("react.forward_ref"), B = Symbol.for("react.suspense"), s1 = Symbol.for("react.suspense_list"), l1 = Symbol.for("react.memo"), Y = Symbol.for("react.lazy"), D = Symbol.for("react.activity"), K = Symbol.for("react.client.reference"), z = y.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, x = Object.prototype.hasOwnProperty, i1 = Array.isArray, S = console.createTask ? console.createTask : function() {
      return null;
    };
    y = {
      "react-stack-bottom-frame": function(s) {
        return s();
      }
    };
    var Q, F = {}, J = y["react-stack-bottom-frame"].bind(
      y,
      l
    )(), G = S(o(l)), T = {};
    e1.Fragment = f, e1.jsx = function(s, d, j, R, Z) {
      var N = 1e4 > z.recentlyCreatedOwnerStacks++;
      return b(
        s,
        d,
        j,
        !1,
        R,
        Z,
        N ? Error("react-stack-top-frame") : J,
        N ? S(o(s)) : G
      );
    }, e1.jsxs = function(s, d, j, R, Z) {
      var N = 1e4 > z.recentlyCreatedOwnerStacks++;
      return b(
        s,
        d,
        j,
        !0,
        R,
        Z,
        N ? Error("react-stack-top-frame") : J,
        N ? S(o(s)) : G
      );
    };
  }()), e1;
}
var H1;
function pe() {
  return H1 || (H1 = 1, process.env.NODE_ENV === "production" ? a1.exports = fe() : a1.exports = Ce()), a1.exports;
}
var r = pe();
function Z1(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = Z1(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function he() {
  for (var e, t, n = 0, o = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Z1(e)) && (o && (o += " "), o += t);
  return o;
}
const j1 = "-", me = (e) => {
  const t = xe(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (c) => {
      const a = c.split(j1);
      return a[0] === "" && a.length !== 1 && a.shift(), P1(a, t) || ge(c);
    },
    getConflictingClassGroupIds: (c, a) => {
      const h = n[c] || [];
      return a && o[c] ? [...h, ...o[c]] : h;
    }
  };
}, P1 = (e, t) => {
  var c;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], o = t.nextPart.get(n), i = o ? P1(e.slice(1), o) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const l = e.join(j1);
  return (c = t.validators.find(({
    validator: a
  }) => a(l))) == null ? void 0 : c.classGroupId;
}, M1 = /^\[(.+)\]$/, ge = (e) => {
  if (M1.test(e)) {
    const t = M1.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, xe = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return we(Object.entries(e.classGroups), n).forEach(([l, c]) => {
    v1(c, o, l, t);
  }), o;
}, v1 = (e, t, n, o) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const l = i === "" ? t : N1(t, i);
      l.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (be(i)) {
        v1(i(o), t, n, o);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([l, c]) => {
      v1(c, N1(t, l), n, o);
    });
  });
}, N1 = (e, t) => {
  let n = e;
  return t.split(j1).forEach((o) => {
    n.nextPart.has(o) || n.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(o);
  }), n;
}, be = (e) => e.isThemeGetter, we = (e, t) => t ? e.map(([n, o]) => {
  const i = o.map((l) => typeof l == "string" ? t + l : typeof l == "object" ? Object.fromEntries(Object.entries(l).map(([c, a]) => [t + c, a])) : l);
  return [n, i];
}) : e, ve = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  const i = (l, c) => {
    n.set(l, c), t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(l) {
      let c = n.get(l);
      if (c !== void 0)
        return c;
      if ((c = o.get(l)) !== void 0)
        return i(l, c), c;
    },
    set(l, c) {
      n.has(l) ? n.set(l, c) : i(l, c);
    }
  };
}, O1 = "!", ye = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, o = t.length === 1, i = t[0], l = t.length, c = (a) => {
    const h = [];
    let p = 0, b = 0, k;
    for (let C = 0; C < a.length; C++) {
      let w = a[C];
      if (p === 0) {
        if (w === i && (o || a.slice(C, C + l) === t)) {
          h.push(a.slice(b, C)), b = C + l;
          continue;
        }
        if (w === "/") {
          k = C;
          continue;
        }
      }
      w === "[" ? p++ : w === "]" && p--;
    }
    const y = h.length === 0 ? a : a.substring(b), L = y.startsWith(O1), M = L ? y.substring(1) : y, f = k && k > b ? k - b : void 0;
    return {
      modifiers: h,
      hasImportantModifier: L,
      baseClassName: M,
      maybePostfixModifierPosition: f
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: c
  }) : c;
}, je = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((o) => {
    o[0] === "[" ? (t.push(...n.sort(), o), n = []) : n.push(o);
  }), t.push(...n.sort()), t;
}, ke = (e) => ({
  cache: ve(e.cacheSize),
  parseClassName: ye(e),
  ...me(e)
}), Le = /\s+/, Re = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: o,
    getConflictingClassGroupIds: i
  } = t, l = [], c = e.trim().split(Le);
  let a = "";
  for (let h = c.length - 1; h >= 0; h -= 1) {
    const p = c[h], {
      modifiers: b,
      hasImportantModifier: k,
      baseClassName: y,
      maybePostfixModifierPosition: L
    } = n(p);
    let M = !!L, f = o(M ? y.substring(0, L) : y);
    if (!f) {
      if (!M) {
        a = p + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (f = o(y), !f) {
        a = p + (a.length > 0 ? " " + a : a);
        continue;
      }
      M = !1;
    }
    const C = je(b).join(":"), w = k ? C + O1 : C, g = w + f;
    if (l.includes(g))
      continue;
    l.push(g);
    const V = i(f, M);
    for (let E = 0; E < V.length; ++E) {
      const B = V[E];
      l.push(w + B);
    }
    a = p + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function He() {
  let e = 0, t, n, o = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = z1(t)) && (o && (o += " "), o += n);
  return o;
}
const z1 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (t = z1(e[o])) && (n && (n += " "), n += t);
  return n;
};
function V1(e, ...t) {
  let n, o, i, l = c;
  function c(h) {
    const p = t.reduce((b, k) => k(b), e());
    return n = ke(p), o = n.cache.get, i = n.cache.set, l = a, a(h);
  }
  function a(h) {
    const p = o(h);
    if (p)
      return p;
    const b = Re(h, n);
    return i(h, b), b;
  }
  return function() {
    return l(He.apply(null, arguments));
  };
}
const v = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, F1 = /^\[(?:([a-z-]+):)?(.+)\]$/i, Me = /^\d+\/\d+$/, Ne = /* @__PURE__ */ new Set(["px", "full", "screen"]), Ve = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ee = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ae = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, _e = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Se = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, A = (e) => q(e) || Ne.has(e) || Me.test(e), P = (e) => W(e, "length", Be), q = (e) => !!e && !Number.isNaN(Number(e)), x1 = (e) => W(e, "number", q), r1 = (e) => !!e && Number.isInteger(Number(e)), Te = (e) => e.endsWith("%") && q(e.slice(0, -1)), u = (e) => F1.test(e), O = (e) => Ve.test(e), Ze = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Pe = (e) => W(e, Ze, I1), Oe = (e) => W(e, "position", I1), ze = /* @__PURE__ */ new Set(["image", "url"]), Fe = (e) => W(e, ze, Ue), Ie = (e) => W(e, "", Ge), t1 = () => !0, W = (e, t, n) => {
  const o = F1.exec(e);
  return o ? o[1] ? typeof t == "string" ? o[1] === t : t.has(o[1]) : n(o[2]) : !1;
}, Be = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Ee.test(e) && !Ae.test(e)
), I1 = () => !1, Ge = (e) => _e.test(e), Ue = (e) => Se.test(e), E1 = () => {
  const e = v("colors"), t = v("spacing"), n = v("blur"), o = v("brightness"), i = v("borderColor"), l = v("borderRadius"), c = v("borderSpacing"), a = v("borderWidth"), h = v("contrast"), p = v("grayscale"), b = v("hueRotate"), k = v("invert"), y = v("gap"), L = v("gradientColorStops"), M = v("gradientColorStopPositions"), f = v("inset"), C = v("margin"), w = v("opacity"), g = v("padding"), V = v("saturate"), E = v("scale"), B = v("sepia"), s1 = v("skew"), l1 = v("space"), Y = v("translate"), D = () => ["auto", "contain", "none"], K = () => ["auto", "hidden", "clip", "visible", "scroll"], z = () => ["auto", u, t], x = () => [u, t], i1 = () => ["", A, P], S = () => ["auto", q, u], Q = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], F = () => ["solid", "dashed", "dotted", "double", "none"], J = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], T = () => ["", "0", u], s = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], d = () => [q, u];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [t1],
      spacing: [A, P],
      blur: ["none", "", O, u],
      brightness: d(),
      borderColor: [e],
      borderRadius: ["none", "", "full", O, u],
      borderSpacing: x(),
      borderWidth: i1(),
      contrast: d(),
      grayscale: T(),
      hueRotate: d(),
      invert: T(),
      gap: x(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Te, P],
      inset: z(),
      margin: z(),
      opacity: d(),
      padding: x(),
      saturate: d(),
      scale: d(),
      sepia: T(),
      skew: d(),
      space: x(),
      translate: x()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", u]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [O]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": s()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": s()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Q(), u]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: K()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": K()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": K()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", r1, u]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: z()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", u]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: T()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: T()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", r1, u]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [t1]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", r1, u]
        }, u]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": S()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": S()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [t1]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [r1, u]
        }, u]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": S()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": S()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", u]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", u]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [y]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [y]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [y]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...G()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...G(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [g]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [g]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [g]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [g]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [g]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [g]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [g]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [g]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [g]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [C]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [C]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [C]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [C]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [C]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [C]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [C]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [C]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [C]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [l1]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [l1]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", u, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [u, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [u, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [O]
        }, O]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [u, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [u, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [u, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [u, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", O, P]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", x1]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [t1]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", u]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", q, x1]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", A, u]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", u]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", u]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...F(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", A, P]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", A, u]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: x()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", u]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", u]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Q(), Oe]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Pe]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Fe]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [M]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [M]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [M]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [L]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [L]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [L]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [l]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [l]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [l]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [l]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [l]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [l]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [l]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [l]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [l]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [l]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [l]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [l]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [l]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [l]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [l]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...F(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: F()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...F()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [A, u]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [A, P]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: i1()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [A, P]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", O, Ie]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [t1]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...J(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": J()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [h]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", O, u]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [p]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [b]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [k]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [V]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [B]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [h]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [p]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [b]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [k]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [V]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [B]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [c]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [c]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [c]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", u]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: d()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", u]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: d()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", u]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [E]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [E]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [E]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [r1, u]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [Y]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [Y]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [s1]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [s1]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", u]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", u]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": x()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": x()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": x()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": x()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": x()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": x()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": x()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": x()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": x()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": x()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": x()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": x()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": x()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": x()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": x()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": x()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": x()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": x()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", u]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [A, P, x1]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, $e = (e, {
  cacheSize: t,
  prefix: n,
  separator: o,
  experimentalParseClassName: i,
  extend: l = {},
  override: c = {}
}) => {
  n1(e, "cacheSize", t), n1(e, "prefix", n), n1(e, "separator", o), n1(e, "experimentalParseClassName", i);
  for (const a in c)
    qe(e[a], c[a]);
  for (const a in l)
    We(e[a], l[a]);
  return e;
}, n1 = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, qe = (e, t) => {
  if (t)
    for (const n in t)
      n1(e, n, t[n]);
}, We = (e, t) => {
  if (t)
    for (const n in t) {
      const o = t[n];
      o !== void 0 && (e[n] = (e[n] || []).concat(o));
    }
}, Ye = (e, ...t) => typeof e == "function" ? V1(E1, e, ...t) : V1(() => $e(E1(), e), ...t), De = (e) => /^\[.+\]$/.test(e), Ke = Ye({
  override: {
    classGroups: {
      "font-size": [
        {
          text: [
            "30",
            "40",
            "50",
            "75",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900",
            "1000",
            "10",
            "11",
            "12",
            "14",
            "16",
            "18",
            "20",
            "23",
            "24",
            "26",
            "28",
            "29",
            "33",
            "37",
            "42",
            "47",
            "base",
            De
          ]
        }
      ]
    }
  }
});
function m(...e) {
  return Ke(he(e));
}
const _ = "outline-offset-1 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-functional-focus-400";
function B1({ className: e }) {
  return /* @__PURE__ */ r.jsxs("a", { className: m("gamma:rounded", _, e), href: "/", children: [
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        width: "96",
        height: "32",
        viewBox: "0 0 96 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "karwei:hidden",
        children: [
          /* @__PURE__ */ r.jsx("rect", { width: "96", height: "32", fill: "#003878" }),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0 0H96V32H0V0Z",
              fill: "#003878"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.3806 13.5953V15.9994H15.7737V20.7992H10.1175L10.1189 11.199H19.1676V8.7998H6.72232C6.10205 8.7998 5.59961 9.33295 5.59961 9.9904V22.0085C5.59961 22.6667 6.10205 23.1998 6.72232 23.1998H19.1676V13.5953H12.3806Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M36.9765 23.1998H23.7542C23.0955 23.1998 22.5605 22.6667 22.5605 22.0085V14.7923C22.5605 14.1341 23.0955 13.601 23.7542 13.601H29.7649V15.9994H26.1689V20.8028H32.1724V11.1975H26.1689V8.7998H35.7836C36.443 8.7998 36.9765 9.33295 36.9765 9.9904V23.1998Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M90.4 23.1998H77.9536C77.3349 23.1998 76.832 22.6667 76.832 22.0085V14.7923C76.832 14.1341 77.3349 13.601 77.9536 13.601H83.6123V15.9994H80.2272V20.8028H85.8771V11.1975H80.2272V8.7998H89.2784C89.8978 8.7998 90.4 9.33295 90.4 9.9904V23.1998Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M53.6822 8.7998H41.4681C40.8599 8.7998 40.3672 9.33223 40.3672 9.9904V23.1998H43.692V11.1968H45.9131V15.9994H48.1323V11.1968H50.3521V23.1998H54.7832V9.9904C54.7832 9.33223 54.2905 8.7998 53.6822 8.7998Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M72.2741 8.7998H59.3414C58.6974 8.7998 58.1758 9.33223 58.1758 9.9904V23.1998H61.696V11.1968H64.0484V15.9994H66.3973V11.1968H68.7469V23.1998H73.4398V9.9904C73.4398 9.33223 72.9174 8.7998 72.2741 8.7998Z",
              fill: "white"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        width: "104",
        height: "42",
        viewBox: "0 0 104 42",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "pointer-events-none block select-none text-[#111316] gamma:hidden",
        children: [
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M102.319 18.6057C101.852 18.3062 104.516 16.3595 102.235 16.5592C101.769 16.5924 101.802 17.2746 101.819 17.624C101.436 16.842 100.837 16.243 100.137 15.9435C99.8543 14.5792 99.6212 13.1982 99.4214 11.8005C98.2226 10.6525 96.774 5.86058 95.6584 0.702637H49.5039V32.1994V41.9829H104V16.2264C102.951 16.9086 103.95 18.456 102.335 18.5891L102.319 18.6057Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx("g", { opacity: "0.8", children: /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M49.4824 32.2155C51.4805 32.7979 53.4618 33.3802 55.9594 32.6315C55.9927 33.6465 56.0593 35.1938 57.4246 35.0774C61.5039 34.7446 66.2825 34.8611 69.1131 37.1905C69.829 38.1555 68.3472 40.0024 69.2296 40.252C70.6116 40.6513 71.9103 38.4883 73.2756 38.8876C73.642 30.9011 70.8281 23.68 69.7624 15.8432C68.2473 14.3957 66.3491 7.19118 65.1836 0.702148H49.4991V32.1989L49.4824 32.2155Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ r.jsx("g", { opacity: "0.8", children: /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M96.1574 41.9994C93.6598 39.6201 90.03 21.5839 90.3131 16.8419C90.2798 16.7088 90.2299 16.5757 90.1966 16.4259C90.0967 13.8636 89.3141 10.8686 87.1995 8.98849C85.9341 8.1732 84.4189 7.35791 82.9703 6.55926C82.2544 7.12497 81.5218 7.67405 80.7892 8.15656C80.7559 7.12497 80.7059 6.11002 79.7901 5.84381C77.4425 3.98029 75.228 5.54431 72.0811 6.82548C70.7324 7.62413 68.4513 7.12497 67.1359 8.2564C67.1026 7.57422 67.1026 7.24144 67.0693 6.54262C65.704 6.65909 68.0517 8.52261 65.7706 8.37286C66.2035 7.6574 65.2711 7.04178 65.2378 6.3596C63.4229 6.85876 64.8715 8.78883 63.0566 8.93858C62.5904 8.63908 65.2545 6.69237 62.9734 6.89203C62.5072 6.92531 62.5405 7.60749 62.5571 7.9569C61.5747 5.97691 59.277 5.16162 57.0792 7.39119C57.0459 6.72565 57.8784 5.66078 57.4788 5.01188C57.4788 5.01188 57.4677 5.01188 57.4455 5.01188C57.4122 5.36129 57.0292 6.02683 57.0459 6.3596C57.0459 5.96028 57.0126 5.56095 56.9959 5.16163C56.6962 5.26146 56.3799 5.37793 56.0802 5.4944C55.8471 5.82717 55.6639 6.15994 55.6639 6.45943C55.6639 6.19321 55.6639 5.927 55.6306 5.66078C54.9313 5.96028 54.2486 6.29304 53.6159 6.62582C52.2839 7.75724 50.3025 8.95521 50.3192 9.45437C49.803 13.6473 49.6199 17.8236 50.0528 21.9166C50.8853 21.8002 51.7011 21.4674 52.134 21.7503C53.0831 22.6987 50.3858 23.9465 51.3348 24.8783C51.7844 24.845 52.2506 24.7951 52.7002 24.7618C52.2339 25.6603 51.6012 26.6253 51.0851 27.5737C51.5013 29.1544 52.0508 30.7018 52.7335 32.2325C53.2163 32.1161 53.6825 32.0329 53.8823 32.166C54.3319 32.7816 53.9989 33.7633 53.9822 34.745C54.0821 34.8781 54.182 35.0112 54.2819 35.1276C54.5983 35.1942 55.0645 35.1609 55.3642 35.1276C55.3642 35.5602 55.2976 35.9596 55.2143 36.3423C56.6463 38.1891 58.1614 40.0859 59.7432 41.9661H96.1574V41.9994Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ r.jsx("g", { opacity: "0.8", children: /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M55.7289 41.9995H90.5612C87.7806 39.3539 83.8678 19.2213 84.1841 13.9136C84.1508 13.7639 84.0842 13.6141 84.0509 13.4477C83.9344 10.6025 83.0686 7.24155 80.6876 5.16173C79.2723 4.24661 77.5906 3.34813 75.9423 2.46629C75.1431 3.09855 74.3272 3.71418 73.5113 4.24661C73.478 3.09855 73.4114 1.96713 72.3958 1.66764C69.7817 -0.412179 67.2841 1.33487 63.7709 2.76578C62.2724 3.64763 59.7083 3.09856 58.2097 4.36309C58.1764 3.59771 58.1764 3.23166 58.1431 2.44965C56.628 2.58276 59.2421 4.64594 56.6946 4.47955C57.1774 3.6809 55.7622 2.99872 55.7289 2.23335C55.6123 2.26663 55.8288 2.2999 55.7289 2.34982V41.9995Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ r.jsx("g", { opacity: "0.8", children: /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M55.4961 0.702637C55.6959 1.25171 55.929 1.7675 56.1621 2.29993C56.645 2.18346 57.1112 2.10027 57.311 2.23338C57.7605 2.84901 57.4275 3.83068 57.4109 4.81235C57.5108 4.94546 57.6107 5.07857 57.7106 5.19504C58.0269 5.2616 58.4931 5.22832 58.7928 5.19504C58.7928 5.62765 58.7262 6.02697 58.643 6.40965C61.9564 10.6858 65.7693 14.9785 69.5822 19.6872C70.9808 20.6023 72.3795 21.5175 73.0954 22.4658C73.828 23.9467 73.2286 26.0265 73.2786 27.5739C78.0239 26.6588 80.8878 30.0197 85.6164 28.6055C85.6497 29.6204 85.7163 31.1678 87.0817 31.0513C91.161 30.7186 95.9396 30.835 98.7701 33.1644C99.4861 34.1295 98.0042 35.9763 98.8867 36.2259C100.269 36.6252 101.567 34.4622 102.933 34.8616C103.299 26.8751 100.485 19.6539 99.4195 11.8172C98.2207 10.6691 96.7721 5.87722 95.6565 0.719271H55.5127L55.4961 0.702637Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ r.jsx("g", { opacity: "0.8", children: /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M103.979 16.2442C102.93 16.9264 103.93 18.4738 102.314 18.6069C101.848 18.3074 104.512 16.3607 102.231 16.5603C101.765 16.5936 101.798 17.2758 101.815 17.6252C100.833 15.6452 98.5348 14.8299 96.337 17.0595C96.3037 16.3939 97.1362 15.3291 96.7366 14.6802C96.7366 14.6802 96.7255 14.6802 96.7033 14.6802C96.67 15.0296 96.287 15.6951 96.3037 16.0279C96.3037 15.6286 96.2704 15.2292 96.2537 14.8299C95.954 14.9298 95.6377 15.0462 95.338 15.1627C95.1049 15.4955 94.9217 15.8282 94.9217 16.1277C94.9217 15.8615 94.9217 15.5953 94.8884 15.3291C94.1891 15.6286 93.5064 15.9613 92.8737 16.2941C91.5417 17.4255 89.5603 18.6235 89.577 19.1227C89.0608 23.2989 88.8777 27.4918 89.3106 31.5849C90.1597 31.4685 90.9589 31.1357 91.3919 31.4185C92.3409 32.3669 89.6436 33.6148 90.5926 34.5466C91.0422 34.5133 91.5084 34.4634 91.958 34.4301C91.4918 35.3286 90.859 36.2936 90.3429 37.242C90.7758 38.8227 91.3086 40.42 91.9913 41.9507C92.4741 41.8343 92.9403 41.8176 93.1401 41.9507H103.996V16.1943L103.979 16.2442Z",
              fill: "#31A1A4"
            }
          ) }),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M49.4845 41.9995H67.1338C66.9673 40.369 66.8007 38.7384 66.6842 37.0745C65.4021 34.6952 63.6372 16.8753 63.7704 12.1167C63.7537 11.9836 63.7204 11.8505 63.7038 11.7007C63.6538 9.13841 63.2542 6.14348 62.172 4.26332C61.5226 3.44803 60.7567 2.63274 60.0074 1.83409C59.6411 2.3998 59.2748 2.94888 58.8919 3.43139C58.8752 2.39981 58.8419 0.952252 58.3757 0.686035C55.8116 0.686035 56.0447 0.819144 54.4463 2.10031C53.7636 2.89896 52.5814 2.39981 51.9154 3.53123C51.8988 2.84905 51.8988 2.51627 51.8821 1.81745C51.1828 1.93392 52.3816 3.79744 51.2161 3.63105C51.4326 2.9156 50.9663 2.29997 50.9497 1.61779C50.0173 2.11695 51.1162 4.13021 50.1838 4.27996C49.9507 3.98047 50.9497 1.95056 49.7842 2.15022C49.5511 2.1835 49.4678 2.86568 49.4845 3.21509V41.9829V41.9995Z",
              fill: "#31A1A4"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              opacity: "0.4",
              d: "M78.4239 29.1382C78.324 29.1548 78.2074 29.1715 78.1075 29.1881C78.1075 29.2214 78.1075 29.2547 78.1075 29.2879C78.2407 29.238 78.3406 29.1881 78.4405 29.1382M76.3259 29.3711C76.1761 29.3711 76.0096 29.4044 75.8597 29.4044C75.7265 30.1864 75.3768 31.1514 75.6599 31.2346C76.4924 30.7521 76.4258 30.0699 76.3259 29.3545M74.6609 29.5541C74.5277 29.5708 74.3945 29.6041 74.2613 29.6207C74.4611 29.7871 74.6609 30.0034 74.844 30.2197C74.7941 30.0367 74.7108 29.8037 74.6775 29.5541M63.9381 30.1199C61.0576 30.1199 57.8608 31.5674 55.0469 33.198C56.9617 37.3077 58.7099 37.2744 59.8755 41.9998H65.2701C64.5542 39.2378 63.9548 40.6188 63.4386 37.7237C63.2388 37.0914 64.7706 34.6622 65.6697 32.6156C66.0693 32.0167 66.5189 31.4343 66.9851 30.852C66.9518 30.802 66.9019 30.7521 66.8519 30.7188C65.9362 30.2862 64.9538 30.1032 63.9381 30.1032",
              fill: "#76B9BC"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M0 0.702637H53.6805V41.9829H14.4524V21.3344H0V0.702637Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M0 0.702637V21.3344H17.5161C17.8824 21.3344 18.4651 21.2845 18.4651 21.8169C18.4651 22.3494 17.7159 22.2329 17.7159 22.8485C17.7159 23.4642 17.7492 23.0981 17.7991 23.2645L19.4475 29.3376L18.3486 33.7301H16.3839L14.4524 26.692V41.9995H53.6971V0.702637H0ZM33.9998 21.3677H37.613V24.6954C37.613 24.8285 37.5464 25.0615 37.1301 25.0615C36.7138 25.0615 36.7971 24.9117 36.7138 24.6788C36.2643 23.2978 35.3818 22.5158 33.9832 22.2828V21.3677H33.9998ZM33.9998 26.8917C34.5826 26.7253 34.9656 26.2262 35.1654 25.4109C35.2486 25.128 35.3485 24.8951 35.6649 24.8951C35.9812 24.8951 35.8813 24.9284 35.9479 24.9949C36.0811 25.1447 36.0811 25.4109 36.0645 25.5273V29.2045C36.0645 29.3376 36.0811 29.6038 35.9479 29.7369C35.8147 29.87 35.7981 29.8367 35.6649 29.8367C35.3485 29.8367 35.2486 29.6038 35.1654 29.3209C34.9656 28.5056 34.5826 28.0065 33.9998 27.8401V26.8917ZM25.2252 6.92545H28.8216L31.3025 17.3578L31.3358 17.4909C31.4191 17.8903 31.469 18.1731 31.9019 18.3561C32.1517 18.456 32.3015 18.5724 32.3015 18.8386C32.3015 19.1049 32.2682 19.005 32.2183 19.0716C32.0518 19.238 31.7021 19.238 31.469 19.238H27.3064C26.9235 19.238 26.5239 19.1881 26.5239 18.8054C26.5239 18.4227 26.6071 18.4892 26.8236 18.3728C27.2565 18.1232 27.3397 17.9901 27.1899 17.3245L26.8569 16.0434V16.0101H24.4592L24.6757 15.1283H26.707V15.0783C26.6904 15.0783 25.0253 7.77402 25.0253 7.77402L25.2252 6.92545ZM21.2457 18.3561C21.329 18.3228 21.4122 18.2896 21.4955 18.2563C21.8285 18.0899 22.2947 17.7239 22.6277 16.4926C22.6277 16.4926 24.4426 9.85384 24.6091 9.27149L25.0253 11.0851L23.4769 16.7422C23.2105 17.7571 23.4436 18.0733 24.0263 18.3229C24.2927 18.4393 24.4925 18.5225 24.4925 18.8386C24.4925 19.1548 24.4592 19.0383 24.3926 19.1049C24.2428 19.2546 23.9264 19.2546 23.6933 19.2546H21.7619C21.329 19.2546 20.8628 19.2047 20.8628 18.7887C20.8628 18.5059 21.0126 18.456 21.2457 18.3561ZM12.6209 19.238H7.92552C7.92552 19.238 7.34276 19.238 7.34276 18.7555C7.34276 18.2729 7.45932 18.406 7.67577 18.3395C8.25853 18.1565 8.25853 18.04 8.25853 17.4576V8.68914C8.25853 8.10679 8.25853 7.99032 7.67577 7.80729C7.45932 7.74074 7.34276 7.59099 7.34276 7.39133C7.34276 6.92545 7.90887 6.90881 7.92552 6.90881H12.6209C12.6209 6.90881 13.2037 6.90881 13.2037 7.39133C13.2037 7.87385 13.0871 7.74074 12.8707 7.80729C12.2879 7.99032 12.2879 8.10679 12.2879 8.68914V17.4576C12.2879 18.04 12.2879 18.1565 12.8707 18.3395C13.0871 18.406 13.2037 18.5558 13.2037 18.7555C13.2037 19.238 12.6209 19.238 12.6209 19.238ZM18.6982 19.238H14.4691C14.1028 19.238 13.6199 19.238 13.6199 18.7555C13.6199 18.2729 13.8031 18.3894 13.9862 18.2896C14.1361 18.2064 14.3026 18.1398 14.3026 17.9402C14.3026 17.7405 14.2193 17.5575 14.1694 17.4244L13.1371 14.3462V14.2963C13.0205 13.9968 12.9206 13.6807 12.9206 13.3479C12.9206 13.0152 13.0538 12.8488 13.237 12.5992L13.3036 12.516L15.2183 9.78728C15.4514 9.47114 15.6513 9.13838 15.6513 8.72241C15.6513 8.30645 15.4514 8.04023 15.0019 7.84057L14.9186 7.80729C14.6855 7.70746 14.5024 7.64091 14.5024 7.35805C14.5024 7.0752 14.5357 7.10847 14.6189 7.04192C14.7688 6.89217 15.0185 6.89217 15.2516 6.89217H18.1155C18.565 6.89217 18.9647 6.92545 18.9647 7.40797C18.9647 7.89049 18.6816 7.87385 18.3819 7.97368H18.3652C17.3163 8.373 16.8834 8.95535 16.3006 9.754L16.1341 9.98694L15.8178 10.4195H15.8011V10.4528L18.4651 17.441C18.4818 17.4909 18.5151 17.5575 18.5317 17.6074C18.6483 17.9069 18.7316 18.1232 19.0646 18.2896C19.2977 18.406 19.4475 18.4892 19.4475 18.7887C19.4475 19.0882 19.4142 18.9884 19.3476 19.0549C19.2311 19.2546 18.9314 19.238 18.6982 19.238ZM23.2771 33.6802H21.3623L19.2144 25.7436L20.33 21.3843H22.1449L24.3094 29.6038L23.2771 33.6802ZM27.0067 22.183C26.1576 22.549 25.9411 23.1647 25.7247 23.98C25.7247 23.98 24.8255 27.524 24.6923 28.1063L24.2428 26.3925L24.8755 23.8136C24.8921 23.7637 24.8921 23.6971 24.9088 23.6472C24.9421 23.4808 24.992 23.3144 24.992 23.1147C24.992 22.6322 24.6757 22.4492 24.3926 22.2828C24.1595 22.1497 23.9597 22.0332 23.9597 21.7837C23.9597 21.5341 24.1595 21.3677 24.5758 21.3677H26.707C27.0234 21.3677 27.3564 21.401 27.3564 21.8003C27.3564 22.0166 27.2398 22.0832 27.0067 22.183ZM33.184 33.6802H28.8549C28.8549 33.6802 28.2722 33.6802 28.2722 33.1977C28.2722 32.7152 28.3887 32.8483 28.6052 32.7817C29.1879 32.5987 29.1879 32.4823 29.1879 31.8999V23.1314C29.1879 22.549 29.1879 22.4326 28.6052 22.2495C28.3887 22.183 28.2722 22.0332 28.2722 21.8336C28.2722 21.3677 28.8383 21.3511 28.8549 21.3511H33.184V33.6802ZM37.7462 30.3858V33.6802H34.0165V32.7817C35.3319 32.6154 36.3808 31.7002 36.8304 30.3692V30.3192C36.9469 30.0863 37.0468 29.8866 37.2966 29.8866C37.5464 29.8866 37.5464 29.9199 37.6296 30.0031C37.7129 30.0863 37.7462 30.3359 37.7462 30.3858ZM39.9773 19.238H35.2819C35.2819 19.238 34.6992 19.238 34.6992 18.7555C34.6992 18.2729 34.8157 18.406 35.0322 18.3395C35.6149 18.1565 35.6149 18.04 35.6149 17.4576V8.68914C35.6149 8.10679 35.6149 7.99032 35.0322 7.80729C34.8157 7.74074 34.6992 7.59099 34.6992 7.39133C34.6992 6.92545 35.2653 6.90881 35.2819 6.90881H39.611V17.4576C39.611 18.04 39.611 18.1565 40.1937 18.3395C40.4102 18.406 40.5267 18.5558 40.5267 18.7555C40.56 19.238 39.9939 19.238 39.9773 19.238ZM45.9714 32.7984C46.1878 32.8649 46.3044 33.0147 46.3044 33.2143C46.3044 33.6802 45.7383 33.6969 45.7216 33.6969H41.0429C41.0429 33.6969 40.4601 33.6969 40.4601 33.2143C40.4601 32.7318 40.5767 32.8649 40.7932 32.7984C41.3759 32.6154 41.3759 32.4989 41.3759 31.9165V23.148C41.3759 22.5657 41.3759 22.4492 40.7932 22.2662C40.5767 22.1996 40.4601 22.0499 40.4601 21.8502C40.4601 21.3843 41.0263 21.3677 41.0429 21.3677H45.7216C45.7216 21.3677 46.3044 21.3677 46.3044 21.8502C46.3044 22.3327 46.1878 22.1996 45.9714 22.2662C45.3886 22.4492 45.3886 22.5657 45.3886 23.148V31.9165C45.3886 32.4822 45.3886 32.6154 45.9714 32.7984ZM45.8049 18.9052C45.3054 19.3212 44.7559 19.4876 43.9567 19.4876C43.1575 19.4876 42.5747 19.2546 42.1085 18.8054C41.5757 18.2563 41.4592 17.5741 41.4592 16.7256V15.5941C41.4592 14.8787 41.4592 13.897 40.4435 13.7805V12.8654C41.3759 12.7656 41.4592 12.1333 41.4592 11.3846V9.38795C41.4592 8.5893 41.3093 8.1567 40.4435 7.84057V6.92545H40.6932C41.7089 6.92545 42.7579 6.92545 43.6736 7.37469C44.7559 7.90712 45.322 8.8056 45.3387 10.0535C45.372 11.7007 44.4562 12.6824 42.4415 13.1483H42.4082V13.2481H42.4415C43.9234 13.4644 45.2887 13.897 45.322 15.6108V17.1415C45.322 17.2746 45.3054 17.441 45.3886 17.5408C45.4219 17.5741 45.4719 17.5908 45.5218 17.5908C45.655 17.5908 45.7383 17.4909 45.8215 17.3745C45.9214 17.2413 46.0213 17.1082 46.2211 17.1082C46.4209 17.1082 46.6707 17.3578 46.6707 17.5575C46.704 18.0234 46.1545 18.639 45.8049 18.9052Z",
              fill: "#1D1E1C"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M78.3663 24.3796C78.3663 25.7772 78.1665 27.0584 77.7502 28.2231C77.3506 29.3878 76.7512 30.3861 75.9686 31.2347C75.1861 32.0666 74.2203 32.7322 73.0715 33.198C71.9226 33.6639 70.6239 33.8969 69.142 33.8969C67.6601 33.8969 66.6112 33.6972 65.5289 33.3145C64.43 32.9152 63.4976 32.3661 62.6984 31.634C61.8992 30.9186 61.2664 30.0367 60.8002 29.0218C60.334 28.0068 60.051 26.8754 59.9844 25.6275H64.7463C64.7963 26.9419 65.2292 27.9569 66.0617 28.6391C66.8942 29.3213 67.9266 29.6707 69.2086 29.6707C70.4907 29.6707 70.6738 29.5376 71.2233 29.2713C71.7894 29.0051 72.239 28.6391 72.572 28.1732C72.905 27.7073 73.1547 27.1582 73.3212 26.526C73.4877 25.8937 73.5543 25.2115 73.5543 24.5127C73.5543 23.1151 73.2047 21.967 72.522 21.0685C71.8394 20.1701 70.7405 19.7208 69.2086 19.7208C67.6768 19.7208 67.6768 19.9038 66.9608 20.2865C66.2449 20.6692 65.6788 21.185 65.2459 21.8506H60.5671L61.1332 6.92578H77.2008V11.1852H65.2459L64.9462 17.2417C65.5622 16.6593 66.2782 16.2267 67.144 15.9439C67.9932 15.661 69.0088 15.5279 70.2076 15.5279C71.4065 15.5279 72.7052 15.7608 73.7375 16.2101C74.7698 16.6593 75.619 17.2916 76.3016 18.0736C76.9843 18.8556 77.5005 19.804 77.8668 20.8855C78.1998 21.967 78.3663 23.1484 78.3663 24.3796Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M89.8863 23.8142C89.8863 23.0322 89.853 22.2169 89.7697 21.3683C89.7031 20.5197 89.5033 19.7377 89.2036 19.0389C88.9039 18.3401 88.471 17.7744 87.8716 17.3251C87.2888 16.8759 86.4896 16.643 85.4573 16.643C84.425 16.643 83.6424 16.8759 83.043 17.3251C82.4603 17.7744 82.0107 18.3401 81.711 19.0389C81.4113 19.7377 81.2281 20.5031 81.1449 21.3683C81.0783 22.2169 81.0283 23.0322 81.0283 23.8142V26.859C81.0283 27.641 81.0616 28.4563 81.1449 29.3049C81.2115 30.1535 81.4113 30.9355 81.711 31.6343C82.0107 32.3331 82.4436 32.8988 83.043 33.3481C83.6258 33.7973 84.425 34.0302 85.4573 34.0302C86.4896 34.0302 87.2722 33.8139 87.8716 33.3481C88.4544 32.8988 88.9039 32.3331 89.2036 31.6343C89.5033 30.9355 89.6865 30.1701 89.7697 29.3049C89.8363 28.4563 89.8863 27.641 89.8863 26.859V23.8142ZM94.6316 25.3283C94.6316 26.3432 94.5983 27.3582 94.5151 28.3399C94.4485 29.3382 94.2986 30.2866 94.0821 31.2183C93.8657 32.1334 93.566 32.9987 93.1497 33.8139C92.7335 34.6292 92.2007 35.328 91.5347 35.9437C90.8686 36.5593 90.0361 37.0751 89.0704 37.5077C88.1047 37.9403 86.9059 38.14 85.4906 38.14C84.0753 38.14 82.8765 37.9237 81.9108 37.5077C80.9451 37.0751 80.1126 36.5593 79.4466 35.9437C78.7806 35.328 78.2311 34.6126 77.8315 33.8139C77.4152 33.0153 77.1155 32.1501 76.8991 31.2183C76.6826 30.3032 76.5494 29.3382 76.4662 28.3399C76.3996 27.3415 76.3496 26.3432 76.3496 25.3283C76.3496 24.3133 76.3829 23.2984 76.4662 22.3167C76.5494 21.335 76.6826 20.37 76.8991 19.4382C77.1155 18.5231 77.4152 17.6579 77.8315 16.8426C78.2477 16.044 78.7806 15.3285 79.4466 14.7129C80.1126 14.0973 80.9451 13.5815 81.9108 13.1489C82.8765 12.7163 84.0753 12.5166 85.4906 12.5166C86.9059 12.5166 88.1047 12.7329 89.0704 13.1489C90.0361 13.5815 90.8686 14.0973 91.5347 14.7129C92.2007 15.3285 92.7501 16.044 93.1497 16.8426C93.566 17.6413 93.8657 18.5065 94.0821 19.4382C94.2986 20.3534 94.4318 21.3184 94.5151 22.3167C94.5817 23.315 94.6316 24.3133 94.6316 25.3283Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M80.7156 9.93729C80.7156 10.3366 80.599 10.6694 80.3826 10.9023C80.1494 11.1353 79.8331 11.2684 79.4168 11.2684C79.0006 11.2684 79.0339 11.2351 78.884 11.1685C78.7342 11.102 78.601 11.0188 78.5011 10.919C78.2513 10.6694 78.1348 10.3033 78.1348 9.85409H78.884C78.884 9.95393 78.884 10.0538 78.9173 10.1702C78.9173 10.2701 78.9839 10.3533 79.0505 10.4364C79.1005 10.4864 79.1504 10.5196 79.217 10.5529C79.2836 10.5862 79.3502 10.6028 79.4335 10.6028C79.6166 10.6028 79.7332 10.5529 79.8331 10.4531C79.9163 10.3532 79.9663 10.2035 79.9663 10.0371V6.95898H80.7489L80.7156 9.93729Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M84.4943 11.1853L84.2112 10.37H82.5129L82.2298 11.1853H81.4473L82.9458 6.90918H83.7949L85.2935 11.1853H84.4943ZM83.362 7.87421L82.746 9.67118H83.9615L83.362 7.87421Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M89.34 11.1853L89.0569 10.37H87.3586L87.0755 11.1853H86.293L87.7915 6.90918H88.6407L90.1392 11.1853H89.34ZM88.2077 7.87421L87.5917 9.67118H88.8072L88.2077 7.87421Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M93.5531 11.1853L92.8371 9.57135H91.888V11.1853H91.1055V6.90918H92.9037C93.1534 6.90918 93.3699 6.94246 93.5697 7.02565C93.7529 7.09221 93.9194 7.19203 94.0359 7.32514C94.1525 7.45825 94.2524 7.59136 94.3023 7.74111C94.3689 7.89085 94.3856 8.07388 94.3856 8.24026C94.3856 8.52312 94.319 8.7727 94.1691 8.989C94.0193 9.2053 93.8361 9.35505 93.603 9.43824L94.3856 11.1853H93.5531ZM93.6197 8.24026C93.6197 8.15707 93.6197 8.07388 93.5697 7.99068C93.5198 7.90749 93.4865 7.84094 93.4365 7.79102C93.3699 7.72447 93.3033 7.67455 93.22 7.65791C93.1368 7.62464 93.0369 7.608 92.9203 7.608H91.888V8.88917H92.9203C93.1368 8.88917 93.32 8.83925 93.4365 8.72278C93.5531 8.60631 93.6197 8.43993 93.6197 8.24026Z",
              fill: "white"
            }
          )
        ]
      }
    )
  ] });
}
function Qe({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        className: m("karwei:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.25 7C2.25 6.58579 2.58579 6.25 3 6.25H21C21.4142 6.25 21.75 6.58579 21.75 7C21.75 7.41421 21.4142 7.75 21 7.75H3C2.58579 7.75 2.25 7.41421 2.25 7ZM2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12ZM2.25 17C2.25 16.5858 2.58579 16.25 3 16.25H21C21.4142 16.25 21.75 16.5858 21.75 17C21.75 17.4142 21.4142 17.75 21 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17Z",
            fill: "currentColor"
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        className: m("gamma:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21 12.5H3V11.5H21V12.5Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21 6.5H3V5.5H21V6.5Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21 18.5H3V17.5H21V18.5Z",
              fill: "currentColor"
            }
          )
        ]
      }
    )
  ] });
}
const Je = S1(function({ className: t, ...n }, o) {
  const { t: i } = I(["ig-header"]);
  return /* @__PURE__ */ r.jsxs(
    "button",
    {
      className: m(
        "relative flex h-11 w-[34px] shrink-0 flex-col items-center justify-center gamma:rounded",
        _,
        t
      ),
      ref: o,
      ...n,
      children: [
        /* @__PURE__ */ r.jsx("span", { className: "absolute -left-4 -top-4 -bottom-4 -right-2" }),
        /* @__PURE__ */ r.jsx(Qe, { className: "size-7 gamma:text-neutral-800 karwei:text-neutral-1000" }),
        /* @__PURE__ */ r.jsx("span", { className: "text-10/none text-neutral-800 lowercase", children: i("ig-header:Menu") })
      ]
    }
  );
});
function Xe(e, t, n) {
  return d1({
    queryKey: ["categories-tree", n],
    queryFn: async ({ signal: o }) => {
      try {
        const i = t.id === "gamma_be" ? `/${n}` : "", { data: l } = await e.shopfront.get(
          `${i}/resources/categories/menu`,
          { signal: o }
        );
        return l;
      } catch {
        return { categories: [] };
      }
    }
  });
}
function u1({
  children: e,
  badge: t,
  ...n
}) {
  return /* @__PURE__ */ r.jsxs(
    "a",
    {
      className: m(
        "grid size-10 grid-cols-1 grid-rows-1 place-items-center hover:bg-neutral-25 gamma:rounded-md",
        _
      ),
      ...n,
      children: [
        /* @__PURE__ */ r.jsx("div", { className: "col-start-1 col-end-2 row-start-1 row-end-2", children: e }),
        !!t && /* @__PURE__ */ r.jsx("div", { className: "col-start-1 col-end-2 row-start-1 row-end-2 flex items-center justify-center", children: /* @__PURE__ */ r.jsx("span", { className: "m-auto min-w-[1.125rem] -translate-y-1/2 translate-x-1/2 self-start rounded-full border border-white px-1 text-center text-[0.75rem] font-bold leading-4 text-white gamma:bg-functional-secondary-500 karwei:bg-functional-conversion-500", children: t }) })
      ]
    }
  );
}
function e2({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        className: m("karwei:hidden", e),
        width: "30",
        height: "28",
        viewBox: "0 0 30 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.7024 11.8001C14.3485 11.8001 16.5248 9.62362 16.5248 6.90009C16.5248 4.17656 14.3485 2.00006 11.7024 2.00006C9.05627 2.00006 6.88 4.17656 6.88 6.90009C6.88 9.62362 9.05627 11.8001 11.7024 11.8001ZM11.7024 13.3001C15.1941 13.3001 18.0248 10.4347 18.0248 6.90009C18.0248 3.36545 15.1941 0.500061 11.7024 0.500061C8.21063 0.500061 5.38 3.36545 5.38 6.90009C5.38 10.4347 8.21063 13.3001 11.7024 13.3001Z",
              fill: "#20272D"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.0239 16.2499C6.31511 16.2499 3.26474 19.1036 2.89866 22.7602C2.85789 23.1673 2.53012 23.4999 2.12093 23.4999C1.71174 23.4999 1.37679 23.1671 1.41055 22.7593C1.78198 18.2734 5.49645 14.7499 10.0239 14.7499H13.9754C18.5028 14.7499 22.2173 18.2734 22.5887 22.7593C22.6225 23.1671 22.2876 23.4999 21.8784 23.4999C21.4692 23.4999 21.1414 23.1673 21.1006 22.7602C20.7346 19.1036 17.6842 16.2499 13.9754 16.2499H10.0239Z",
              fill: "#20272D"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M30 19C30 23.9706 25.9706 28 21 28C16.0294 28 12 23.9706 12 19C12 14.0294 16.0294 10 21 10C25.9706 10 30 14.0294 30 19Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M29 19C29 23.4183 25.4183 27 21 27C16.5817 27 13 23.4183 13 19C13 14.5817 16.5817 11 21 11C25.4183 11 29 14.5817 29 19Z",
              fill: "#6BBD51"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M20.545 22.4965C20.3195 22.5183 20.0959 22.4374 19.9341 22.2752L17.2308 19.5854C16.9274 19.2813 16.9225 18.7834 17.2198 18.4731C17.5172 18.1629 18.0042 18.1579 18.3076 18.4619L20.36 20.4996L23.5987 15.8382C23.8409 15.4813 24.3202 15.3928 24.6692 15.6404C25.0183 15.888 25.1049 16.3781 24.8627 16.735L21.1045 22.1619C20.9753 22.3522 20.7706 22.4746 20.545 22.4965Z",
              fill: "white"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        className: m("gamma:hidden", e),
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.2174 7.22917C17.2174 10.6694 14.4338 13.4583 11 13.4583C7.56623 13.4583 4.78261 10.6694 4.78261 7.22917C4.78261 3.78889 7.56623 1 11 1C14.4338 1 17.2174 3.78889 17.2174 7.22917ZM16.2609 7.22917C16.2609 10.1402 13.9055 12.5 11 12.5C8.0945 12.5 5.73913 10.1402 5.73913 7.22917C5.73913 4.31817 8.0945 1.95833 11 1.95833C13.9055 1.95833 16.2609 4.31817 16.2609 7.22917Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M0.956522 24C0.956522 20.0305 4.16839 16.8125 8.13043 16.8125H13.8696C17.8316 16.8125 21.0435 20.0305 21.0435 24H22C22 19.5012 18.3599 15.8542 13.8696 15.8542H8.13043C3.64012 15.8542 0 19.5012 0 24H0.956522Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12C24.4183 12 28 15.5817 28 20Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M27.1148 20C27.1148 23.9274 23.931 27.1111 20.0037 27.1111C16.0763 27.1111 12.8926 23.9274 12.8926 20C12.8926 16.0727 16.0763 12.8889 20.0037 12.8889C23.931 12.8889 27.1148 16.0727 27.1148 20Z",
              fill: "#008933"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M20.0037 27.1111C23.931 27.1111 27.1148 23.9274 27.1148 20C27.1148 16.0727 23.931 12.8889 20.0037 12.8889C16.0763 12.8889 12.8926 16.0727 12.8926 20C12.8926 23.9274 16.0763 27.1111 20.0037 27.1111Z",
              fill: "#008933"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M23.8546 17.1595L19.5643 22.8247L16.668 19.9284L17.2785 19.3179L19.445 21.4844L23.1459 16.6665L23.8546 17.1595Z",
              fill: "white"
            }
          )
        ]
      }
    )
  ] });
}
function G1({ className: e, ...t }) {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        className: m("karwei:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
          /* @__PURE__ */ r.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.6449 6.40003C17.6449 9.93467 14.8143 12.8001 11.3225 12.8001C7.83075 12.8001 5.00012 9.93467 5.00012 6.40003C5.00012 2.86539 7.83075 0 11.3225 0C14.8143 0 17.6449 2.86539 17.6449 6.40003ZM16.1449 6.40003C16.1449 9.12356 13.9686 11.3001 11.3225 11.3001C8.67638 11.3001 6.50012 9.12356 6.50012 6.40003C6.50012 3.6765 8.67638 1.5 11.3225 1.5C13.9686 1.5 16.1449 3.6765 16.1449 6.40003Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M2.51877 23.2601C2.88485 19.6035 5.93523 16.7498 9.64402 16.7498H13.5955C17.3043 16.7498 20.3547 19.6035 20.7208 23.2601C20.7615 23.6672 21.0893 23.9999 21.4985 23.9999C21.9077 23.9999 22.2426 23.667 22.2089 23.2592C21.8374 18.7733 18.123 15.2498 13.5955 15.2498H9.64402C5.11657 15.2498 1.40209 18.7733 1.03067 23.2592C0.996903 23.667 1.33185 23.9999 1.74104 23.9999C2.15023 23.9999 2.47801 23.6672 2.51877 23.2601Z",
              fill: "currentColor"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        className: m("gamma:hidden", e),
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
          /* @__PURE__ */ r.jsxs("g", { clipPath: "url(#clip0_7073_39481)", children: [
            /* @__PURE__ */ r.jsx(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.5 7C18.5 10.5899 15.5899 13.5 12 13.5C8.41015 13.5 5.5 10.5899 5.5 7C5.5 3.41015 8.41015 0.5 12 0.5C15.5899 0.5 18.5 3.41015 18.5 7ZM17.5 7C17.5 10.0376 15.0376 12.5 12 12.5C8.96243 12.5 6.5 10.0376 6.5 7C6.5 3.96243 8.96243 1.5 12 1.5C15.0376 1.5 17.5 3.96243 17.5 7Z",
                fill: "currentColor"
              }
            ),
            /* @__PURE__ */ r.jsx(
              "path",
              {
                d: "M1.5 23.5C1.5 19.3579 4.85786 16 9 16H15C19.1421 16 22.5 19.3579 22.5 23.5H23.5C23.5 18.8056 19.6944 15 15 15H9C4.30558 15 0.5 18.8056 0.5 23.5H1.5Z",
                fill: "currentColor"
              }
            )
          ] }),
          /* @__PURE__ */ r.jsx("defs", { children: /* @__PURE__ */ r.jsx("clipPath", { id: "clip0_7073_39481", children: /* @__PURE__ */ r.jsx(
            "rect",
            {
              width: "24",
              height: "24",
              fill: "white",
              transform: "translate(0 0.5)"
            }
          ) }) })
        ]
      }
    )
  ] });
}
function r2({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ r.jsxs(
    "svg",
    {
      className: m("karwei:hidden", e),
      width: "30",
      height: "28",
      viewBox: "0 0 30 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ r.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.7024 11.8001C14.3485 11.8001 16.5248 9.62362 16.5248 6.90009C16.5248 4.17656 14.3485 2.00006 11.7024 2.00006C9.05627 2.00006 6.88 4.17656 6.88 6.90009C6.88 9.62362 9.05627 11.8001 11.7024 11.8001ZM11.7024 13.3001C15.1941 13.3001 18.0248 10.4347 18.0248 6.90009C18.0248 3.36545 15.1941 0.500061 11.7024 0.500061C8.21063 0.500061 5.38 3.36545 5.38 6.90009C5.38 10.4347 8.21063 13.3001 11.7024 13.3001Z",
            fill: "#20272D"
          }
        ),
        /* @__PURE__ */ r.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0239 16.2499C6.31511 16.2499 3.26474 19.1036 2.89866 22.7602C2.85789 23.1673 2.53012 23.4999 2.12093 23.4999C1.71174 23.4999 1.37679 23.1671 1.41055 22.7593C1.78198 18.2734 5.49645 14.7499 10.0239 14.7499H13.9754C18.5028 14.7499 22.2173 18.2734 22.5887 22.7593C22.6225 23.1671 22.2876 23.4999 21.8784 23.4999C21.4692 23.4999 21.1414 23.1673 21.1006 22.7602C20.7346 19.1036 17.6842 16.2499 13.9754 16.2499H10.0239Z",
            fill: "#20272D"
          }
        ),
        /* @__PURE__ */ r.jsxs(
          "mask",
          {
            id: "path-2-outside-1_6807_24299",
            maskUnits: "userSpaceOnUse",
            x: "12",
            y: "10",
            width: "18",
            height: "18",
            fill: "black",
            children: [
              /* @__PURE__ */ r.jsx("rect", { fill: "white", x: "12", y: "10", width: "18", height: "18" }),
              /* @__PURE__ */ r.jsx("path", { d: "M29 19C29 23.4183 25.4183 27 21 27C16.5817 27 13 23.4183 13 19C13 14.5817 16.5817 11 21 11C25.4183 11 29 14.5817 29 19Z" })
            ]
          }
        ),
        /* @__PURE__ */ r.jsx(
          "path",
          {
            d: "M29 19C29 23.4183 25.4183 27 21 27C16.5817 27 13 23.4183 13 19C13 14.5817 16.5817 11 21 11C25.4183 11 29 14.5817 29 19Z",
            fill: "#003878"
          }
        ),
        /* @__PURE__ */ r.jsx(
          "path",
          {
            d: "M29 19H28C28 22.866 24.866 26 21 26V27V28C25.9706 28 30 23.9706 30 19H29ZM21 27V26C17.134 26 14 22.866 14 19H13H12C12 23.9706 16.0294 28 21 28V27ZM13 19H14C14 15.134 17.134 12 21 12V11V10C16.0294 10 12 14.0294 12 19H13ZM21 11V12C24.866 12 28 15.134 28 19H29H30C30 14.0294 25.9706 10 21 10V11Z",
            fill: "white",
            mask: "url(#path-2-outside-1_6807_24299)"
          }
        ),
        /* @__PURE__ */ r.jsx(
          "path",
          {
            d: "M20.6672 21.8359C20.7894 21.7621 20.8506 21.7252 20.9159 21.7111C20.9713 21.6992 21.0287 21.6992 21.0841 21.7111C21.1494 21.7252 21.2106 21.7621 21.3328 21.8359L22.7833 22.7113C23.1986 22.962 23.4063 23.0873 23.5534 23.0618C23.6756 23.0406 23.781 22.964 23.8389 22.8543C23.9086 22.7222 23.8535 22.4861 23.7433 22.0137L23.3583 20.3635C23.3259 20.2245 23.3097 20.155 23.3165 20.0885C23.3222 20.0321 23.3399 19.9776 23.3684 19.9285C23.4019 19.8707 23.4559 19.824 23.5638 19.7305L24.8463 18.6194C25.213 18.3018 25.3963 18.143 25.4175 17.9951C25.4351 17.8724 25.3947 17.7484 25.3083 17.6595C25.2042 17.5525 24.9625 17.532 24.4791 17.491L22.792 17.3478C22.6498 17.3358 22.5788 17.3297 22.5176 17.3028C22.4658 17.2799 22.4195 17.2463 22.3816 17.2041C22.3369 17.1544 22.3091 17.0888 22.2535 16.9574L21.5929 15.399C21.4044 14.9541 21.3101 14.7317 21.1762 14.666C21.0651 14.6114 20.9349 14.6114 20.8238 14.666C20.6899 14.7317 20.5956 14.9541 20.4071 15.399L19.7465 16.9574C19.6909 17.0888 19.6631 17.1544 19.6184 17.2041C19.5805 17.2463 19.5342 17.2799 19.4824 17.3028C19.4212 17.3297 19.3502 17.3358 19.208 17.3478L17.5209 17.491C17.0375 17.532 16.7958 17.5525 16.6917 17.6595C16.6053 17.7484 16.5649 17.8724 16.5825 17.9951C16.6037 18.143 16.787 18.3018 17.1537 18.6194L18.4362 19.7305C18.5441 19.824 18.5981 19.8707 18.6316 19.9285C18.6601 19.9776 18.6778 20.0321 18.6835 20.0885C18.6903 20.155 18.6741 20.2245 18.6417 20.3635L18.2567 22.0137C18.1465 22.4861 18.0914 22.7222 18.1611 22.8543C18.219 22.964 18.3244 23.0406 18.4466 23.0618C18.5937 23.0873 18.8014 22.962 19.2167 22.7113L20.6672 21.8359Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function U1(e) {
  return d1({
    queryKey: ["session"],
    queryFn: async ({ signal: t }) => {
      const { data: n } = await e.myaccount.get(
        "/api/session-data",
        { signal: t }
      );
      return n;
    }
  });
}
function f1(e) {
  return J1(() => {
    const t = g1.create({
      baseURL: e.CHECKOUT_URL,
      withCredentials: !0
    }), n = g1.create({
      baseURL: e.MYACCOUNT_URL,
      withCredentials: !0
    }), o = g1.create({
      baseURL: e.SHOPFRONT_URL,
      withCredentials: !0
    });
    for (const i of [t, n, o])
      i.interceptors.request.use(async (l) => {
        const { Authorization: c } = await ie();
        return l.headers.Authorization = c, l;
      });
    return {
      checkout: t,
      myaccount: n,
      shopfront: o
    };
  }, [
    e.CHECKOUT_URL,
    e.MYACCOUNT_URL,
    e.SHOPFRONT_URL
  ]);
}
function $1({
  formula: e,
  onLogin: t
}) {
  const { t: n } = I(["ig-header"]), o = f1(e), i = T1(), l = o1(U1(o)), { isLoggedIn: c, gammaPro: a } = l.data ?? {}, h = k1(
    (b) => /* @__PURE__ */ r.jsx(
      ae,
      {
        trigger: /* @__PURE__ */ r.jsx(ce, { asChild: !0, children: b }),
        initLocation: "global_header",
        onLogin: async () => {
          await Promise.all([
            i.invalidateQueries({ queryKey: ["number-of-products"] }),
            i.invalidateQueries({ queryKey: ["session"] })
          ]), await (t == null ? void 0 : t());
        },
        onMount: ({ onOpenChange: k }) => {
          const y = () => k(!0);
          return document.addEventListener("openAccountDialog", y), () => {
            document.removeEventListener("openAccountDialog", y);
          };
        }
      }
    ),
    [t, i]
  ), p = k1(() => {
    $({
      type: "header",
      data: { user_selected_element: "My account" }
    });
  }, []);
  return l.isPending ? /* @__PURE__ */ r.jsx(q1, {}) : c ? /* @__PURE__ */ r.jsxs(u1, { href: n("ig-header:/myaccount"), onClick: p, children: [
    /* @__PURE__ */ r.jsx("span", { className: "sr-only", children: n("ig-header:MyAccount") }),
    /* @__PURE__ */ r.jsx("span", { className: "block size-6", children: a ? /* @__PURE__ */ r.jsx(r2, {}) : /* @__PURE__ */ r.jsx(e2, {}) })
  ] }) : h(
    /* @__PURE__ */ r.jsxs(
      "button",
      {
        type: "submit",
        className: m(
          "flex h-10 items-center gap-3 px-2 hover:bg-neutral-25 gamma:rounded-md",
          _
        ),
        onClick: p,
        children: [
          /* @__PURE__ */ r.jsx(G1, {}),
          /* @__PURE__ */ r.jsx("div", { className: "hidden lg:flex", children: /* @__PURE__ */ r.jsx("span", { children: n("ig-header:Login") }) })
        ]
      }
    )
  );
}
function q1() {
  const { t: e } = I(["ig-header"]);
  return /* @__PURE__ */ r.jsx(u1, { href: e("ig-header:/myaccount"), children: /* @__PURE__ */ r.jsx("span", { className: "flex h-10 items-center gap-3 px-2 hover:bg-neutral-25 gamma:rounded-md", children: /* @__PURE__ */ r.jsx("span", { className: "block size-6", children: /* @__PURE__ */ r.jsx(G1, {}) }) }) });
}
function t2({ className: e, ...t }) {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        className: m("karwei:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M9.87276 20.9999C10.3472 20.9999 10.7319 20.6162 10.7319 20.1428C10.7319 19.6694 10.3472 19.2856 9.87276 19.2856C9.3983 19.2856 9.01367 19.6694 9.01367 20.1428C9.01367 20.6162 9.3983 20.9999 9.87276 20.9999Z",
              fill: "currentColor",
              stroke: "currentColor",
              strokeWidth: "1.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M19.322 20.9999C19.7964 20.9999 20.1811 20.6162 20.1811 20.1428C20.1811 19.6694 19.7964 19.2856 19.322 19.2856C18.8475 19.2856 18.4629 19.6694 18.4629 20.1428C18.4629 20.6162 18.8475 20.9999 19.322 20.9999Z",
              fill: "currentColor",
              stroke: "currentColor",
              strokeWidth: "1.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ r.jsx(
            "path",
            {
              d: "M3 3H6.43636L8.73873 14.4771C8.81729 14.8718 9.03246 15.2262 9.34657 15.4785C9.66069 15.7308 10.0537 15.8648 10.4569 15.8571H18.8073C19.2104 15.8648 19.6035 15.7308 19.9176 15.4785C20.2317 15.2262 20.4469 14.8718 20.5255 14.4771L21.9 7.28571H7.29545",
              stroke: "currentColor",
              strokeWidth: "1.6"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r.jsxs(
      "svg",
      {
        className: m("gamma:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: [
          /* @__PURE__ */ r.jsxs("g", { clipPath: "url(#clip0_4000_12998)", children: [
            /* @__PURE__ */ r.jsx(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 3.5H3.04861C3.27716 3.5 3.47662 3.65497 3.5331 3.87644L6.97466 17.3707C7.1441 18.0351 7.74248 18.5 8.42813 18.5H19.9746C20.6712 18.5 21.2762 18.0204 21.4351 17.3421L23.6992 7.67541C23.9196 6.73423 23.2054 5.83333 22.2387 5.83333H5.0642L4.50208 3.62931C4.33264 2.96492 3.73426 2.5 3.04861 2.5H0V3.5ZM7.94364 17.1236L5.31923 6.83333H22.2387C22.5609 6.83333 22.799 7.13363 22.7255 7.44736L20.4614 17.114C20.4085 17.3401 20.2068 17.5 19.9746 17.5H8.42813C8.19958 17.5 8.00012 17.345 7.94364 17.1236Z",
                fill: "currentColor"
              }
            ),
            /* @__PURE__ */ r.jsx(
              "path",
              {
                d: "M11.3278 21.8163C11.3278 22.3686 10.88 22.8163 10.3278 22.8163C9.77547 22.8163 9.32776 22.3686 9.32776 21.8163C9.32776 21.264 9.77547 20.8163 10.3278 20.8163C10.88 20.8163 11.3278 21.264 11.3278 21.8163Z",
                fill: "currentColor"
              }
            ),
            /* @__PURE__ */ r.jsx(
              "path",
              {
                d: "M18.6812 21.8163C18.6812 22.3686 18.2335 22.8163 17.6812 22.8163C17.1289 22.8163 16.6812 22.3686 16.6812 21.8163C16.6812 21.264 17.1289 20.8163 17.6812 20.8163C18.2335 20.8163 18.6812 21.264 18.6812 21.8163Z",
                fill: "currentColor"
              }
            )
          ] }),
          /* @__PURE__ */ r.jsx("defs", { children: /* @__PURE__ */ r.jsx("clipPath", { id: "clip0_4000_12998", children: /* @__PURE__ */ r.jsx("rect", { width: "24", height: "24", fill: "white" }) }) })
        ]
      }
    )
  ] });
}
function n2(e) {
  return d1({
    queryKey: ["number-of-products"],
    queryFn: async ({ signal: t }) => {
      try {
        const { data: n } = await e.checkout.get(
          "/resources/cart/numberOfProducts",
          { signal: t }
        );
        return parseInt(n, 10) || 0;
      } catch {
        return 0;
      }
    }
  });
}
function W1({ formula: e }) {
  const { t } = I(["ig-header"]), n = f1(e), i = o1(n2(n)).data ?? 0, l = i >= 100 ? "99+" : i;
  return /* @__PURE__ */ r.jsxs(
    u1,
    {
      href: t("ig-header:/cart"),
      badge: l,
      onClick: () => {
        $({
          type: "header",
          data: { user_selected_element: "Cart" }
        });
      },
      children: [
        /* @__PURE__ */ r.jsx("span", { className: "sr-only", children: t("ig-header:Cart") }),
        /* @__PURE__ */ r.jsx(t2, {})
      ]
    }
  );
}
const o2 = S1, s2 = (e, t) => {
  const { as: n, children: o, className: i, ...l } = e, c = n || "a";
  return /* @__PURE__ */ r.jsxs(
    c,
    {
      className: m(
        "relative group flex h-full items-center text-functional-primary-800 gamma:rounded outline-none",
        i
      ),
      ...l,
      ref: t,
      children: [
        /* @__PURE__ */ r.jsx("span", { className: "flex items-center gamma:rounded outline-offset-1 group-focus-visible:outline group-focus-visible:outline-[3px] group-focus-visible:outline-functional-focus-400", children: o }),
        /* @__PURE__ */ r.jsx("span", { className: "opacity-0 absolute bottom-0 left-0 right-0 h-1 bg-brand-primary block transition w-full group-hover:opacity-100" })
      ]
    }
  );
}, c1 = o2(s2);
function l2({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        className: m("karwei:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            d: "M6.29289 11.0518L12 16.7589L17.7071 11.0518C18.0976 10.6613 18.0976 10.0281 17.7071 9.63762C17.3166 9.2471 16.6834 9.2471 16.2929 9.63762L12 13.9305L7.70711 9.63762C7.31658 9.2471 6.68342 9.2471 6.29289 9.63762C5.90237 10.0281 5.90237 10.6613 6.29289 11.0518Z",
            fill: "currentColor"
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        className: m("gamma:hidden", e),
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.1283 16.1232L5.08726 9.21375L5.78766 8.50001L12.1216 14.7156L18.3339 8.50333L19.041 9.21043L12.1283 16.1232Z",
            fill: "currentColor"
          }
        )
      }
    )
  ] });
}
function A1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        className: m("karwei:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            d: "M11.0518 7.0927L16.7589 12.7998L11.0518 18.5069C10.6613 18.8974 10.0281 18.8974 9.63762 18.5069C9.2471 18.1164 9.2471 17.4832 9.63762 17.0927L13.9305 12.7998L9.63762 8.50691C9.2471 8.11639 9.2471 7.48322 9.63762 7.0927C10.0281 6.70217 10.6613 6.70217 11.0518 7.0927Z",
            fill: "currentColor"
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        className: m("gamma:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0479 11.6659L10.1384 18.7069L9.42469 18.0065L15.6403 11.6725L9.42801 5.46028L10.1351 4.75317L17.0479 11.6659Z",
            fill: "currentColor"
          }
        )
      }
    )
  ] });
}
function i2({
  className: e,
  categories: t,
  formula: n
}) {
  const { t: o, i18n: i } = I(["ig-header"]), l = X1(), c = m1(null), a = m1(null), h = m1(null), [p, b] = w1(!1), [k, y] = w1([]), L = k.at(-1), M = (L == null ? void 0 : L.subCategories) ?? t;
  return y1(() => {
    const f = (g) => {
      p && g.code === "Escape" && (b(!1), a.current.focus());
    }, C = (g) => {
      p && g.code === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey && !c.current.contains(document.activeElement) && b(!1);
    }, w = (g) => {
      p && !c.current.contains(g.target) && b(!1);
    };
    return window.addEventListener("keydown", f), window.addEventListener("keyup", C), window.addEventListener("click", w), () => {
      window.removeEventListener("keydown", f), window.removeEventListener("keyup", C), window.removeEventListener("click", w);
    };
  }, [p]), /* @__PURE__ */ r.jsxs("ul", { className: m("flex gap-4 z-20 xl:gap-8", e), children: [
    /* @__PURE__ */ r.jsxs("li", { ref: c, children: [
      /* @__PURE__ */ r.jsxs(
        c1,
        {
          as: "button",
          "aria-controls": l,
          "aria-expanded": p,
          onClick: () => b((f) => !f),
          ref: a,
          children: [
            /* @__PURE__ */ r.jsx("span", { children: o("ig-header:Catalog") }),
            /* @__PURE__ */ r.jsx(l2, {})
          ]
        }
      ),
      /* @__PURE__ */ r.jsx(
        "div",
        {
          className: m(
            "fixed inset-0 z-10 transform-gpu bg-transparent opacity-0 backdrop-blur-sm pointer-events-none",
            "transition-all duration-300 ease-in-out",
            p && "bg-black/50 opacity-100"
          )
        }
      ),
      /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: m(
            "absolute inset-x-0 z-10 mx-8 flex flex-col bg-white gamma:rounded-lg",
            !p && "hidden"
          ),
          id: l,
          hidden: !p,
          children: [
            /* @__PURE__ */ r.jsxs("div", { className: "flex flex-col gap-6 p-6", children: [
              /* @__PURE__ */ r.jsxs("div", { className: "flex flex-row gap-2", ref: h, children: [
                /* @__PURE__ */ r.jsx("h2", { className: "font-bold", children: /* @__PURE__ */ r.jsx(
                  "button",
                  {
                    disabled: k.length === 0,
                    className: m("gamma:rounded", _),
                    onClick: (f) => {
                      f.stopPropagation(), y([]);
                    },
                    children: o("ig-header:Catalog")
                  }
                ) }),
                k.map((f, C) => /* @__PURE__ */ r.jsxs(ee, { children: [
                  /* @__PURE__ */ r.jsx(A1, { className: "size-6" }),
                  /* @__PURE__ */ r.jsx(
                    "button",
                    {
                      className: m("gamma:rounded", _),
                      onClick: (w) => {
                        w.stopPropagation(), de(() => {
                          y((g) => g.slice(0, C + 1));
                        }), a2(h.current);
                      },
                      disabled: C === k.length - 1,
                      children: f.name
                    }
                  )
                ] }, f.uid))
              ] }),
              /* @__PURE__ */ r.jsx("ul", { className: "block lg:columns-3 xl:columns-4", children: M.map((f) => {
                const C = f.subCategories ? f.subCategories.length > 0 : !1, w = C ? "button" : "a";
                return /* @__PURE__ */ r.jsx("li", { className: "mb-4", children: /* @__PURE__ */ r.jsxs(
                  w,
                  {
                    className: m(
                      "group inline-flex items-center gap-1 text-start text-functional-primary-800 gamma:rounded",
                      "outline outline-3 outline-transparent",
                      _
                    ),
                    onClick: (g) => {
                      C && (g.stopPropagation(), y((V) => [...V, f]));
                    },
                    href: C ? void 0 : _1(f, n, i.language),
                    children: [
                      /* @__PURE__ */ r.jsx("span", { children: f.name }),
                      C && /* @__PURE__ */ r.jsx(A1, { className: "size-4 transition group-hover:translate-x-2" })
                    ]
                  }
                ) }, f.uid);
              }) })
            ] }),
            /* @__PURE__ */ r.jsx("div", { className: "w-full bg-neutral-50 px-6 py-4 gamma:rounded-b-lg", children: /* @__PURE__ */ r.jsx(
              "a",
              {
                className: m(
                  "inline-flex items-center gap-1 text-functional-primary-800 underline-offset-[3px] hover:underline gamma:rounded",
                  _
                ),
                href: L ? _1(L, n, i.language) : o("ig-header:/catalog"),
                children: L ? o("ig-header:ShowAllIn", { name: L.name }) : o("ig-header:ShowEntireCatalog")
              }
            ) })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(
      c1,
      {
        href: o("ig-header:/advice"),
        onClick: () => {
          $({
            type: "header",
            data: {
              user_selected_element: "Advies"
            }
          });
        },
        children: o("ig-header:Advice")
      }
    ) }),
    /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(
      c1,
      {
        href: o("ig-header:/promotions"),
        onClick: () => {
          $({
            type: "header",
            data: {
              user_selected_element: "Actie"
            }
          });
        },
        children: o("ig-header:Promotions")
      }
    ) }),
    /* @__PURE__ */ r.jsx("li", { className: "gamma:hidden", children: /* @__PURE__ */ r.jsx(
      c1,
      {
        href: o("ig-header:/inspiration"),
        onClick: () => {
          $({
            type: "header",
            data: {
              user_selected_element: "Wooninspiratie"
            }
          });
        },
        children: o("ig-header:Inspiration")
      }
    ) })
  ] });
}
function a2(e) {
  if (e) {
    const t = Array.from(e.querySelectorAll("button:enabled")), n = t[t.length - 1];
    n == null || n.focus();
  }
}
function _1(e, t, n) {
  return `${t.id === "gamma_be" ? `/${n.slice(0, 2)}` : ""}/assortiment${e.categoryUrl}`;
}
function c2({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        className: m("karwei:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            d: "M18.7663 6.2377C18.3753 5.84531 17.9111 5.53404 17.4002 5.32168C16.8893 5.10931 16.3417 5 15.7887 5C15.2357 5 14.6881 5.10931 14.1772 5.32168C13.6663 5.53404 13.2021 5.84531 12.8112 6.2377L11.9998 7.05166L11.1884 6.2377C10.3987 5.44548 9.32768 5.00041 8.21089 5.00041C7.09409 5.00041 6.02303 5.44548 5.23334 6.2377C4.44365 7.02993 4 8.10441 4 9.22479C4 10.3452 4.44365 11.4196 5.23334 12.2119L6.0447 13.0258L11.9998 19L17.9549 13.0258L18.7663 12.2119C19.1574 11.8197 19.4677 11.354 19.6794 10.8415C19.891 10.3289 20 9.77958 20 9.22479C20 8.67 19.891 8.12064 19.6794 7.60811C19.4677 7.09558 19.1574 6.6299 18.7663 6.2377V6.2377Z",
            stroke: "currentColor",
            strokeWidth: "1.6"
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        className: m("gamma:hidden", e),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.15264 4.25C5.19156 4.25 3.48112 5.5822 3.00097 7.4836L2.89525 7.90226C2.65282 8.8623 2.7109 9.87361 3.06164 10.7996L3.24185 11.2753C3.63951 12.3252 4.30415 13.2531 5.17011 13.9675L11.9995 19.6018L18.829 13.9675C19.6949 13.2531 20.3596 12.3252 20.7572 11.2753L20.9374 10.7996C21.2882 9.87362 21.3463 8.8623 21.1038 7.90226L20.9981 7.4836C20.5179 5.5822 18.8075 4.25 16.8464 4.25C15.2307 4.25 13.7526 5.15942 13.0242 6.6016L11.9995 8.63053L10.9748 6.6016C10.2464 5.15942 8.76833 4.25 7.15264 4.25ZM2.03141 7.23876C2.62369 4.89332 4.73358 3.25 7.15264 3.25C9.14565 3.25 10.969 4.3718 11.8674 6.15079L11.9995 6.41233L12.1316 6.15079C13.0301 4.3718 14.8534 3.25 16.8464 3.25C19.2655 3.25 21.3754 4.89332 21.9677 7.23876L22.0734 7.65742C22.3659 8.81596 22.2959 10.0364 21.8726 11.1538L21.6924 11.6295C21.2331 12.8421 20.4655 13.9138 19.4653 14.7389L11.9995 20.8982L4.53373 14.7389C3.53359 13.9138 2.76597 12.8421 2.30669 11.6295L2.12648 11.1538C1.70321 10.0364 1.63313 8.81596 1.92569 7.65742L2.03141 7.23876Z",
            fill: "currentColor"
          }
        )
      }
    )
  ] });
}
const d2 = d1({
  queryKey: ["number-of-favorites"],
  queryFn: () => {
    var t;
    if (typeof localStorage > "u")
      return 0;
    const e = localStorage.getItem("wishlist");
    return e ? (t = JSON.parse(e)) == null ? void 0 : t.length : 0;
  }
});
function u2() {
  const { t: e } = I(["ig-header"]), n = o1(d2).data, o = n >= 100 ? "99+" : n;
  return /* @__PURE__ */ r.jsxs(
    u1,
    {
      href: e("ig-header:/favorites"),
      badge: o,
      onClick: () => {
        $({
          type: "header",
          data: { user_selected_element: "Favorites" }
        });
      },
      children: [
        /* @__PURE__ */ r.jsx("span", { className: "sr-only", children: e("ig-header:Favorites") }),
        /* @__PURE__ */ r.jsx(c2, {})
      ]
    }
  );
}
function f2({
  alternateLang: e
}) {
  return /* @__PURE__ */ r.jsx(
    "a",
    {
      href: e.href,
      className: m(
        "text-14/5 text-neutral-800 py-1 px-2 gamma:rounded hover:bg-neutral-25",
        _
      ),
      children: /* @__PURE__ */ r.jsx(
        "span",
        {
          title: e.name,
          lang: `${e.code.toLowerCase()}-BE`,
          children: e.code
        }
      )
    }
  );
}
function C2({
  alternateLang: e,
  withUSP: t = !1
}) {
  return !t && !e ? null : /* @__PURE__ */ r.jsx("div", { className: "mx-auto h-10 hidden w-full md:max-w-screen-md md:px-6 lg:flex lg:max-w-screen-lg lg:px-8 xl:max-w-screen-xl", children: /* @__PURE__ */ r.jsxs("div", { className: "flex flex-1 items-center border-b border-neutral-100", children: [
    t && /* @__PURE__ */ r.jsxs("ul", { className: "flex w-full items-center gap-8 text-75/none gamma:text-neutral-400 karwei:text-neutral-600", children: [
      /* @__PURE__ */ r.jsxs("li", { className: "flex items-center", children: [
        /* @__PURE__ */ r.jsx(b1, {}),
        /* @__PURE__ */ r.jsxs("div", { children: [
          /* @__PURE__ */ r.jsx("span", { className: "font-bold", children: "Gratis" }),
          " ophalen in jouw bouwmarkt"
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs("li", { className: "flex items-center", children: [
        /* @__PURE__ */ r.jsx(b1, {}),
        /* @__PURE__ */ r.jsxs("div", { children: [
          /* @__PURE__ */ r.jsx("span", { className: "font-bold", children: "Gratis" }),
          " bezorgd vanaf €50*"
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs("li", { className: "flex items-center", children: [
        /* @__PURE__ */ r.jsx(b1, {}),
        "Voor 21:00 uur besteld, morgen in huis*"
      ] })
    ] }),
    e && /* @__PURE__ */ r.jsx("div", { className: "ml-auto", children: /* @__PURE__ */ r.jsx(f2, { alternateLang: e }) })
  ] }) });
}
function b1() {
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "karwei:hidden",
        children: /* @__PURE__ */ r.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3375 8.8764C16.8215 9.36042 16.8215 10.1452 16.3375 10.6292L10.9667 16L7.66156 12.6949C7.17753 12.2109 7.17753 11.4261 7.66156 10.9421C8.14558 10.4581 8.93033 10.4581 9.41435 10.9421L10.9667 12.4944L14.5847 8.8764C15.0687 8.39238 15.8534 8.39238 16.3375 8.8764Z",
            fill: "#6BBD51"
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(
      "svg",
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "gamma:hidden",
        children: /* @__PURE__ */ r.jsx("path", { d: "M16 9L9.8125 15L7 12.2727", stroke: "#1ACB50", strokeWidth: "2" })
      }
    )
  ] });
}
const p2 = re(
  () => import("@intergamma/kiosk-ui").then((e) => ({
    default: e.KioskController
  }))
);
function Y1({ formula: e }) {
  const [t, n] = w1(!1);
  return y1(() => {
    ue().then(n);
  }, []), t ? /* @__PURE__ */ r.jsx(te, { fallback: null, children: /* @__PURE__ */ r.jsx(p2, { formula: e }) }) : null;
}
function D1() {
  const e = T1();
  y1(() => {
    function t() {
      e.invalidateQueries({ queryKey: ["number-of-favorites"] }), e.invalidateQueries({ queryKey: ["number-of-products"] }), e.invalidateQueries({ queryKey: ["session"] });
    }
    return document.body.addEventListener("refreshHeader", t), () => {
      document.body.removeEventListener("refreshHeader", t);
    };
  }, [e]);
}
function R2({
  formula: e,
  alternateUrl: t,
  onLogin: n
}) {
  var p;
  const o = f1(e), { i18n: i } = I(), l = i.language.substring(0, 2), a = ((p = o1(
    Xe(o, e, l)
  ).data) == null ? void 0 : p.categories) ?? [];
  let h;
  return t && (h = {
    code: l === "fr" ? "NL" : "FR",
    href: t,
    name: l === "fr" ? "Nederlands" : "Français"
  }), D1(), /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(Y1, { formula: e }),
    /* @__PURE__ */ r.jsxs(
      "header",
      {
        className: m(
          "z-10 inset-x-0 flex flex-col border-b border-neutral-100 bg-white",
          "lg:transform-none"
        ),
        role: "banner",
        children: [
          /* @__PURE__ */ r.jsx(C2, { alternateLang: h, withUSP: !1 }),
          /* @__PURE__ */ r.jsxs("nav", { className: "relative mx-auto flex w-full flex-col items-stretch gap-3 p-4 lg:py-0 md:max-w-screen-md md:px-6 lg:h-24 lg:max-w-screen-lg lg:flex-row lg:px-8 xl:max-w-screen-xl", children: [
            /* @__PURE__ */ r.jsxs("div", { className: "flex w-full gap-4", children: [
              /* @__PURE__ */ r.jsxs("div", { className: "flex w-full items-stretch gap-8 lg:w-auto", children: [
                /* @__PURE__ */ r.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ r.jsx(B1, {}) }),
                /* @__PURE__ */ r.jsx("div", { className: "hidden lg:contents", children: /* @__PURE__ */ r.jsx(i2, { categories: a, formula: e }) })
              ] }),
              /* @__PURE__ */ r.jsx("div", { className: "hidden flex-1 justify-center lg:flex", children: /* @__PURE__ */ r.jsx("div", { className: "flex-1 flex items-center lg:max-w-[27.5rem]", children: /* @__PURE__ */ r.jsx(ne, {}) }) }),
              /* @__PURE__ */ r.jsxs("ul", { className: "flex items-center", children: [
                /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(le, { fallback: /* @__PURE__ */ r.jsx(q1, {}), children: /* @__PURE__ */ r.jsx($1, { formula: e, onLogin: n }) }) }),
                /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(u2, {}) }),
                /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(W1, { formula: e }) })
              ] })
            ] }),
            /* @__PURE__ */ r.jsxs("div", { className: "flex w-full items-center gap-2 lg:hidden", children: [
              /* @__PURE__ */ r.jsx(
                oe,
                {
                  trigger: /* @__PURE__ */ r.jsx(Je, {}),
                  categories: a,
                  formula: e
                }
              ),
              /* @__PURE__ */ r.jsx("div", { className: "relative flex items-center h-[46px] flex-1", children: /* @__PURE__ */ r.jsx(se, { variant: "new" }) })
            ] })
          ] })
        ]
      }
    )
  ] });
}
function H2({ formula: e }) {
  var o;
  const t = f1(e), n = o1(U1(t));
  return D1(), /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(Y1, { formula: e }),
    /* @__PURE__ */ r.jsx(
      "header",
      {
        className: "flex flex-col border-b border-neutral-100",
        role: "banner",
        children: /* @__PURE__ */ r.jsxs("nav", { className: "mx-auto flex w-full justify-between items-center gap-3 p-4 md:max-w-screen-md md:px-6 lg:h-24 lg:max-w-screen-lg lg:px-8 xl:max-w-screen-xl", children: [
          /* @__PURE__ */ r.jsx(B1, {}),
          /* @__PURE__ */ r.jsxs("ul", { className: "flex items-center", children: [
            !((o = n.data) != null && o.isLoggedIn) && /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx($1, { formula: e }) }),
            /* @__PURE__ */ r.jsx("li", { children: /* @__PURE__ */ r.jsx(W1, { formula: e }) })
          ] })
        ] })
      }
    )
  ] });
}
export {
  H2 as MinimalHeader,
  R2 as NewHeader
};
